import { DefaultResponse } from "../../types/default-response.dto";
import { TCreateACtivationCredit, TParams } from "../../types/types";
import { createAuthClient } from "../auth/auth.client";
import {
  CREATE_ACTIVATION_CREDIT,
  DELETE_ACTIVATION_CREDIT,
  FETCH_ACTIVATION_CREDITS,
  FETCH_MONTHY_CREDIT_USAGE,
} from "./activation-credits.queries";

export const getActivationCredits = async (
  params?: TParams
): Promise<DefaultResponse> => {
  const authClient = createAuthClient();
  return authClient.request(FETCH_ACTIVATION_CREDITS, {
    params: { ...params },
  });
};

export const createActivationCredit = async (
  createActivationCreditInput: TCreateACtivationCredit
): Promise<DefaultResponse> => {
  const authClient = createAuthClient();
  return authClient.request(CREATE_ACTIVATION_CREDIT, {
    createActivationCreditInput,
  });
};

export const deleteActivationCredit = async (
  activationCreditId: string
): Promise<DefaultResponse> => {
  const authClient = createAuthClient();
  return authClient.request(DELETE_ACTIVATION_CREDIT, {
    activationCreditId,
  });
};

export const getMonthlyCreditUsage = async (): Promise<DefaultResponse> => {
  const authClient = createAuthClient();
  return authClient.request(FETCH_MONTHY_CREDIT_USAGE, {});
};
